import type { PostureModeStrategy } from '@/components/posture-analysis/lib/posture-mode-strategy';

export type CaptureCanvasTouchAction = 'none' | 'pan-y';

/** Mobile pose/pin drag editing — disabled in layman self-assessment (page scroll instead). */
export function shouldUseMobilePoseEditMode(
  mode: PostureModeStrategy,
  isNarrowViewport: boolean,
  canSetPoseLandmark: boolean,
): boolean {
  return isNarrowViewport && canSetPoseLandmark && mode.mode !== 'self-assessment';
}

/** Inline capture canvas touch-action: practitioner mobile blocks pan for drag; SA allows vertical scroll. */
export function inlineCaptureCanvasTouchAction(
  mode: PostureModeStrategy,
  isNarrowViewport: boolean,
  mobileEditMode: boolean,
): CaptureCanvasTouchAction | undefined {
  if (mobileEditMode) return 'none';
  if (isNarrowViewport && mode.mode === 'self-assessment') return 'pan-y';
  return undefined;
}

/** Self-assessment capture on narrow viewports — document scroll + sticky merged toolbar. */
export function useSelfAssessmentMobileCaptureShell(
  mode: PostureModeStrategy,
  isNarrowViewport: boolean,
): boolean {
  return mode.mode === 'self-assessment' && isNarrowViewport;
}

/** Cap inline canvas height once at least one view is captured (not while assign queue is open). */
export function shouldCapSelfAssessmentMobileCanvas(
  mode: PostureModeStrategy,
  isNarrowViewport: boolean,
  hasAnyCapturedImage: boolean,
  unassignedCount: number,
): boolean {
  return (
    useSelfAssessmentMobileCaptureShell(mode, isNarrowViewport) &&
    hasAnyCapturedImage &&
    unassignedCount === 0
  );
}
